import apiClient from './client'

// tb_protector_alarm_log (ผ่าน /protector-alarm-log/) — 1 แถว = 1 alarm event
// ต่อ (protector, alarm_type). ended_at = null แปลว่ายัง active อยู่ตอนนี้
export interface ProtectorAlarmLogRow {
  alarm_log_id: number
  station_id: number
  station_code: string
  station_name: string
  protector_id: number
  protector_name: string
  alarm_id: number
  alarm_code: string
  alarm_name: string
  started_at: string
  ended_at: string | null
}

// tb_meter_warning_log (ผ่าน /meter-warning-log/)
export interface MeterWarningLogRow {
  warning_log_id: number
  station_id: number
  station_code: string
  station_name: string
  meter_id: number
  meter_code: string
  meter_name: string
  warning_id: number
  warning_code: string
  warning_name: string
  current_value: string | number | null
  threshold_value: string | number | null
  phase: string | null
  details: Record<string, unknown>
  is_inferred: boolean
  close_reason: string | null
  started_at: string
  ended_at: string | null
  last_seen_at: string | null
}

export interface LogPagination {
  page: number
  per_page: number
  total: number
  pages: number
  has_next: boolean
  has_previous: boolean
}

// summary นับจาก "ทั้งตาราง" ฝั่ง server ไม่ใช่จากแถวที่หน้านี้โหลดมา — เดิม
// frontend นับเองจาก 200 แถวแรก ทำให้ alarm ที่ยัง active แต่เริ่มมานานแล้ว
// (หลุดออกจาก 200 แถวแรก) ไม่ถูกนับ ยอดในการ์ดเลยไม่ตรงกับ badge ข้าง sidebar
export interface AlarmLogSummary {
  total_active: number
  by_type: { gfr: number; ovpr: number; uvpr: number }
  stations_affected: number
}

export interface WarningLogSummary {
  total_active: number
  stations_affected: number
}

export interface LogResponse<T, S> {
  data: T[]
  pagination: LogPagination
  summary: S
}

export type AlarmCode = 'gfr' | 'ovpr' | 'uvpr'

interface LogParams {
  active_only?: boolean
  station_id?: number
  page?: number
  per_page?: number
}

// ไม่ส่ง active_only = ดึง log ทั้งหมด (ประวัติ), ส่ง active_only:true = เฉพาะที่
// ยัง active (ended_at IS NULL)
//
// backend เรียง "ที่ยังเกิดอยู่ขึ้นก่อน แล้วค่อย -started_at" มาให้แล้ว จึงไม่
// ต้องเรียงซ้ำฝั่ง client (เรียงซ้ำก็ได้แค่ภายในหน้าเดียวอยู่ดี)
export async function getProtectorAlarmLog(
  params: LogParams & { alarm_code?: AlarmCode } = {}
): Promise<LogResponse<ProtectorAlarmLogRow, AlarmLogSummary>> {
  const response = await apiClient.get<LogResponse<ProtectorAlarmLogRow, AlarmLogSummary>>(
    '/protector-alarm-log/',
    { params: { per_page: 25, ...params } }
  )
  return response.data
}

export async function getMeterWarningLog(
  params: LogParams = {}
): Promise<LogResponse<MeterWarningLogRow, WarningLogSummary>> {
  const response = await apiClient.get<LogResponse<MeterWarningLogRow, WarningLogSummary>>(
    '/meter-warning-log/',
    { params: { per_page: 25, ...params } }
  )
  return response.data
}
